import {
    CreateOrderDialogFlow,
    CreateOrderDialogMode,
    CreateOrderDialogType,
    SelectedMainUserState,
} from "../../createOrderTypes"
import { MeetingServiceOrder } from "../../../../../modules/merchant/accounting/accounting/accountingTypes"
import { BookingConfig, DynamicMainFormValues, MeetingServiceConfig } from "./formTypes"
import { DateTimeFactory } from "../../../../../modules/localization/useDateTime"
import { getValuesFromConfig } from "./formLib"

export function mergeValuesWithConfig({
    existing,
    config,
    user,
    dateTimeFactory,
    dialogType,
    orderDetails,
    mode,
    flowConfig,
    setFieldValue,
}: {
    existing: DynamicMainFormValues
    config?: MeetingServiceConfig | BookingConfig
    user: SelectedMainUserState
    dateTimeFactory: DateTimeFactory
    dialogType: CreateOrderDialogType
    orderDetails?: MeetingServiceOrder
    mode?: CreateOrderDialogMode
    flowConfig?: CreateOrderDialogFlow
    setFieldValue?: (field: string, value: any) => void
}): DynamicMainFormValues {
    const generated = getValuesFromConfig(user, dateTimeFactory, dialogType, config, orderDetails, mode, flowConfig)

    const merged: DynamicMainFormValues = { ...existing }

    Object.entries(generated).forEach(([key, value]) => {
        if (!(key in merged)) {
            merged[key] = value
            if (setFieldValue) {
                setFieldValue(key, value)
            }
        }
    })

    return merged
}
